import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header-messages" }
const _hoisted_2 = { class: "header-messages__counter" }

import { computed, onMounted, ref, watch } from "vue"
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue"
import HeaderMessagesModal from "./HeaderMessagesModal.vue"
import { headerStore } from "@/store/header"
import { rootStore } from "@/store/index"


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderMessagesButton',
  setup(__props, { expose: __expose }) {

const store = headerStore()
const root = rootStore()
const $modal = ref<InstanceType<typeof HeaderMessagesModal> | null>(null)

const count = computed(() => store.unreadMessagesCount)
const hasChatsAccess = computed(() => store.chatsAccess !== false)

const onClick = () => {
	if(!hasChatsAccess.value) return;

	$modal.value?.open()
}

__expose({ open: onClick })

const fetchOnce = () => {
	if (!store.getDialogs?.length) {
		store.fetchDialogs()
	}
}

onMounted(() => {
	if (root.globalJWT) {
		fetchOnce()
		return
	}
	const unwatch = watch(() => root.globalJWT, (token) => {
		if (token) {
			fetchOnce()
			unwatch()
		}
	})
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["header-messages__btn", {'header-messages__btn-invalid': !hasChatsAccess.value}]),
      onClick: onClick
    }, [
      _createVNode(AppIcon, {
        name: "envelope",
        width: "20px",
        height: "20px",
        cursor: hasChatsAccess.value? 'pointer': 'default',
        color: hasChatsAccess.value? '#FFFFFF': '#979797',
        class: "header-messages__icon"
      }, null, 8, ["cursor", "color"]),
      _createElementVNode("span", _hoisted_2, _toDisplayString(count.value), 1)
    ], 2),
    _createVNode(HeaderMessagesModal, {
      ref_key: "$modal",
      ref: $modal
    }, null, 512)
  ]))
}
}

})